import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { CompetitionPropType, SeriesPropType } from '../../common/types';

import Spinner from '../../common/Spinner';

const LOGO_PLACEHOLDER = '/assets/images/placeholder.png';

class Practice extends Component {
  static propTypes = {
    competitions: PropTypes.arrayOf(CompetitionPropType).isRequired,
    competitionsLoading: PropTypes.bool.isRequired,
    serieses: PropTypes.arrayOf(SeriesPropType).isRequired,
  };

  state = {
    practiceCompetitionId: null,
    practiceSeriesId: null,
    canShowAnswers: false,
    hasTimeLimit: true,
  };

  onChooseCompetition = competitionId => {
    const { practiceCompetitionId, practiceSeriesId } = this.state;
    const empty = practiceCompetitionId === competitionId;

    this.setState({
      practiceCompetitionId: empty ? null : competitionId,
      practiceSeriesId: empty ? null : practiceSeriesId,
    });
  };

  onChooseSeries = seriesId => {
    const { practiceSeriesId } = this.state;
    const empty = practiceSeriesId === seriesId;

    this.setState({
      practiceSeriesId: empty ? null : seriesId,
      canShowAnswers: false,
      hasTimeLimit: true,
    });
  };

  onChooseCanShowAnswers = canShowAnswers => {
    this.setState({ canShowAnswers });
  };

  onChooseHasTimeLimit = hasTimeLimit => {
    this.setState({ hasTimeLimit });
  };

  renderChooseCompetition = () => {
    const { competitions, competitionsLoading } = this.props;
    const { practiceCompetitionId } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-4 mb-3">
          <div className="col-auto d-flex align-items-center">
            <div className="HomeArchivePractice-title-icon mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-practice-choose-competition"
                defaultMessage="Valitse kilpailu"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          {competitionsLoading && (
            <div className="col">
              <Spinner center />
            </div>
          )}

          {!competitionsLoading &&
            competitions.map(competition => (
              <div
                key={competition.id}
                className="HomeArchivePractice-competition col-auto"
              >
                <button
                  type="button"
                  className={classNames(
                    'HomeArchivePractice-button',
                    'btn',
                    'btn-transparent',
                    'btn-lg',
                    'pl-3',
                    'd-flex',
                    'align-items-center',
                    { active: practiceCompetitionId === competition.id }
                  )}
                  onClick={() => this.onChooseCompetition(competition.id)}
                >
                  <img
                    src={
                      competition.logo
                        ? competition.logoURL()
                        : LOGO_PLACEHOLDER
                    }
                    alt={competition.name}
                    className="HomeArchivePractice-competition-logo mr-4"
                  />

                  <p className="my-0">{competition.name}</p>
                </button>
              </div>
            ))}
        </div>
      </>
    );
  };

  renderChooseSeries = () => {
    const { serieses } = this.props;
    const { practiceCompetitionId, practiceSeriesId } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-5 mb-3">
          <div className="col-auto d-flex align-items-center">
            <div className="HomeArchivePractice-title-icon mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-practice-choose-series"
                defaultMessage="Valitse sarja"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          {serieses
            .filter(s => s.competition_id === practiceCompetitionId)
            .map(series => (
              <div key={series.id} className="col-auto">
                <button
                  type="button"
                  className={classNames(
                    'HomeArchivePractice-button',
                    'btn',
                    'btn-transparent',
                    'btn-lg',
                    'd-flex',
                    'align-items-center',
                    { active: practiceSeriesId === series.id }
                  )}
                  onClick={() => this.onChooseSeries(series.id)}
                >
                  <p className="my-0">{series.name}</p>
                </button>
              </div>
            ))}
        </div>
      </>
    );
  };

  renderChooseCanShowAnswers = () => {
    const { canShowAnswers } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-5 mb-3">
          <div className="col d-flex align-items-center">
            <div className="HomeArchivePractice-answers-title-icon col-auto mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-practice-choose-can-show-answers"
                defaultMessage="Haluatko sallia ratkaisujen näyttämisen?"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="col-auto">
            <button
              type="button"
              className={classNames(
                'HomeArchivePractice-button',
                'btn',
                'btn-transparent',
                'btn-lg',
                'd-flex',
                'align-items-center',
                { active: !canShowAnswers }
              )}
              onClick={() => this.onChooseCanShowAnswers(false)}
            >
              <p className="my-0">
                <FormattedMessage
                  id="home-archive-practice-can-show-answers-no"
                  defaultMessage="Älä salli"
                />
              </p>
            </button>
          </div>

          <div className="col-auto">
            <button
              type="button"
              className={classNames(
                'HomeArchivePractice-button',
                'btn',
                'btn-transparent',
                'btn-lg',
                'd-flex',
                'align-items-center',
                { active: canShowAnswers }
              )}
              onClick={() => this.onChooseCanShowAnswers(true)}
            >
              <p className="my-0">
                <FormattedMessage
                  id="home-archive-practice-can-show-answers-yes"
                  defaultMessage="Salli"
                />
              </p>
            </button>
          </div>
        </div>
      </>
    );
  };

  renderChooseTimeLimit = () => {
    const { hasTimeLimit } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-5 mb-3">
          <div className="col d-flex align-items-center">
            <div className="HomeArchivePractice-time-limit-title-icon col-auto mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-practice-choose-time-limit"
                defaultMessage="Haluatko harjoitella aikarajan kanssa?"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="col-auto">
            <button
              type="button"
              className={classNames(
                'HomeArchivePractice-button',
                'btn',
                'btn-transparent',
                'btn-lg',
                'd-flex',
                'align-items-center',
                { active: hasTimeLimit }
              )}
              onClick={() => this.onChooseHasTimeLimit(true)}
            >
              <p className="my-0">
                <FormattedMessage
                  id="home-archive-practice-has-time-limit-yes"
                  defaultMessage="Aikarajalla"
                />
              </p>
            </button>
          </div>

          <div className="col-auto">
            <button
              type="button"
              className={classNames(
                'HomeArchivePractice-button',
                'btn',
                'btn-transparent',
                'btn-lg',
                'd-flex',
                'align-items-center',
                { active: !hasTimeLimit }
              )}
              onClick={() => this.onChooseHasTimeLimit(false)}
            >
              <p className="my-0">
                <FormattedMessage
                  id="home-archive-practice-has-time-limit-no"
                  defaultMessage="Ilman aikarajaa"
                />
              </p>
            </button>
          </div>
        </div>
      </>
    );
  };

  render() {
    const {
      practiceCompetitionId,
      practiceSeriesId,
      canShowAnswers,
      hasTimeLimit,
    } = this.state;

    return (
      <div className="HomeArchivePractice">
        {this.renderChooseCompetition()}

        {!!practiceCompetitionId && this.renderChooseSeries()}

        {!!practiceSeriesId && (
          <>
            {this.renderChooseCanShowAnswers()}
            {this.renderChooseTimeLimit()}

            <Link
              to={`/kilpailu/${practiceCompetitionId}/series/${practiceSeriesId}?canShowAnswers=${canShowAnswers}&hasTimeLimit=${hasTimeLimit}`}
              className="btn btn-primary btn-block btn-lg mt-5"
            >
              <FormattedMessage
                id="home-archive-practice-start"
                defaultMessage="Aloita"
              />
            </Link>
          </>
        )}
      </div>
    );
  }
}

export default Practice;
